import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardBody, CardHeader } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { getBookingContainersLoading } from 'store/actions';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import Spinners from 'components/Common/Spinner';

const ContainerRow = ({ data, bookingId }) => {
	const dispatch = useDispatch();

	return (
		<tr>
			<td>{data?.containerNumber}</td>
			<td>{data?.cargoweight} KG</td>
			<td>{data?.vgmweight} KG</td>
			<td>{data?.status}</td>
		</tr>
	);
};

const BookingContainers = props => {
	const [getAllBookingContainers, setAllBookingContainers] = useState([]);
	const [addContainerShow, setAddContainerShow] = useState(false);
	const dispatch = useDispatch();

	const BookingContainers = createSelector(
		state => state.Bookings,
		bookings => ({
			isLoading: bookings.booking_containers_loading,
			dataValue: bookings.booking_containers_data
		})
	);

	const { isLoading, dataValue } = useSelector(BookingContainers);

	useEffect(() => {
		dispatch(getBookingContainersLoading({ bookingId: props.bookingId }));
	}, [props.bookingId]);

	useEffect(() => {
		if (dataValue?.length > 0) {
			setAllBookingContainers(dataValue[0]?.containers);
		}
	}, [dataValue]);

	return (
		<React.Fragment>
			<Row>
				<Col xl={12}>
					<Card>
						<CardHeader className="bg-primary">
							<div className="d-flex ">
								<div className="flex-grow-1">
									<h4 className="card-title text-white mt-1 font-size-12">
										Booking Containers ({getAllBookingContainers?.length})
									</h4>
								</div>
							</div>
						</CardHeader>
						<CardBody>
							<div id="bookingContainer">
								<div className="bookingContainer">
									<div className="d-flex align-items-center">
										{isLoading ? (
											<div className="mt-5">
												<Spinners setLoading={() => {}} />
											</div>
										) : (
											<div className="table-responsive w-100">
												<table className="table text-center table-bordered table-striped">
													<thead>
														<tr>
															<th>Container Number</th>
															<th>Cargo Weight</th>
															<th>VGM Weight</th>
															<th>Status</th>
														</tr>
													</thead>
													<tbody className="font-size-11">
														{getAllBookingContainers &&
															getAllBookingContainers.length > 0 &&
															getAllBookingContainers?.map((data, index) => {
																return <ContainerRow data={data} key={index} bookingId={props.bookingId} />;
															})}
														{!getAllBookingContainers && (
															<tr>
																<td colSpan="5" className="text-center">
																	No Data Available
																</td>
															</tr>
														)}
													</tbody>
												</table>
											</div>
										)}
									</div>
								</div>
							</div>
						</CardBody>
					</Card>
				</Col>
			</Row>
		</React.Fragment>
	);
};

export default BookingContainers;
